(ns frontend.view.modals.pre-investment-check.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.pre-investment-check :as pre-investment-check]
   [common.util :as cu]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :pre-investment-check-modal)

(defn view-body
  [state]
  (let [options pre-investment-check/status-options]
    [:div
     {:class "flex flex-col gap-3"}
     [labelled-input/view
      {:label       (loc/tr :pre-investment-check/status)
       :editor-type :editor.type/select
       :value       (->> options
                         (cu/filter-by :value (:pre-investment-check/status @state))
                         (first))
       :options     options
       :on-change   (fn [v]
                      (swap! state assoc :pre-investment-check/status v))}]

     [labelled-input/view
      {:data-type :data.type/datetime
       :label     (loc/tr :pre-investment-check/checked-on)
       :value     (:pre-investment-check/checked-on @state)
       :on-change (fn [utc-ms]
                    (swap! state assoc :pre-investment-check/checked-on utc-ms))}]

     (when (= :pre-investment-check.status/conditionally-approved
              (:pre-investment-check/status @state))
       [labelled-input/view
        {:data-type :data.type/text-simple
         :label     (loc/tr :pre-investment-check/conditions)
         :value     (:pre-investment-check/conditions @state)
         :on-change (fn [v]
                      (swap! state assoc :pre-investment-check/conditions v))}])

     [labelled-input/view
      {:data-type :data.type/text-multiline
       :label     (loc/tr :pre-investment-check/note)
       :value     (:pre-investment-check/note @state)
       :on-change (fn [v]
                    (swap! state assoc :pre-investment-check/note v))}]]))

(defn footer-view
  [{:keys [state init-state attribute oppo-id on-close! read-only?]}]
  (let [no-updates? (->> [:pre-investment-check/status
                          :pre-investment-check/checked-on
                          :pre-investment-check/conditions
                          :pre-investment-check/note]
                         (remove (fn [attr]
                                   (= (get @state attr)
                                      (get init-state attr))))
                         (empty?))]
    [:<>
     [modal/left-cancel-only on-close! nil]
     [modal/right-single-button
      nil
      (or no-updates? read-only?)
      (fn []
        (let [pre-investment-check (select-keys @state
                                                [:pre-investment-check/status
                                                 :pre-investment-check/checked-on
                                                 :pre-investment-check/conditions
                                                 :pre-investment-check/note])
              pre-investment-check-changes (assoc
                                            pre-investment-check
                                            :pre-investment-check/conditions
                                            (if (= :pre-investment-check.status/conditionally-approved
                                                   (:pre-investment-check/status pre-investment-check))
                                              (:pre-investment-check/conditions pre-investment-check)
                                              nil))
              pre-investment-check-id (-> oppo-id
                                          session/get-entity
                                          (get attribute))]
          (if pre-investment-check-id
            (entity-actions/*->entity-update!
             pre-investment-check-id
             pre-investment-check-changes
             on-close!
             (fn []))
            (entity-actions/*->create
             (assoc pre-investment-check-changes :entity/type :entity.type/pre-investment-check)
             (fn [resp]
               (let [pre-investment-check-id (-> resp
                                                 :body
                                                 :db/id)]
                 (entity-actions/*->field-update!
                  oppo-id
                  attribute
                  pre-investment-check-id
                  on-close!
                  (fn []))))
             (fn [e] (logging/error "Could not create pre-investment-check" e pre-investment-check))))))
      (loc/tr :submit)
      nil]]))

(defn view
  [{:keys [state]}]
  (fn [{:keys [shown? close-modal! props topmost?]}]
    (let [{:keys [attribute oppo-id start-state read-only?]} props]
      (swap! state (fn [prev-state] (if (nil? prev-state) start-state prev-state)))
      [modal/view
       {:visible?     (and shown? topmost?)
        :hide!        close-modal!
        :backdrop     "static"
        :success-text (loc/tr :success-guest-invited)
        :on-close!    close-modal!}
       (loc/tr attribute)
       [view-body state]
       [footer-view
        {:state      state
         :init-state start-state
         :attribute  attribute
         :oppo-id    oppo-id
         :read-only? read-only?
         :on-close!  close-modal!}]])))
